import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'
import { useCallback, useEffect, useState } from 'react'

import { CrudStore } from 'core/types/crudStore'

export const useTopPartnerId = (pid: string) => {
  const [isAlive, setIsAlive] = useState(true)
  const [topPartnerId, setTopPartnerId] = useState<string>()

  useEffect(() => {
    return () => {
      setIsAlive(false)
    }
  }, [])

  const fetchTopPartnerId = useCallback(async () => {
    if (pid && pid.indexOf('new-') === -1) {
      const crud = CrudStore.get(CrudStoreItem.PartnerAllData, 'PartnerDashboard')
      const partner = await crud.getById({ id: pid, keyField: 'PartnerID' })
      if (isAlive && partner) {
        setTopPartnerId(partner.TopPartnerID)
      }
    }
  }, [isAlive, pid])

  useEffect(() => {
    setTopPartnerId(undefined)
    fetchTopPartnerId()
  }, [fetchTopPartnerId, pid])

  return pid && pid.indexOf('new-') > -1 ? pid : topPartnerId
}
